"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.remove = remove;
exports.count = count;
exports.totalCount = totalCount;
var modals = {};

function add(bodyClass) {
  // Set variable and default if none
  if (!modals[bodyClass]) {
    modals[bodyClass] = 0;
  }
  modals[bodyClass] += 1;
}

function remove(bodyClass) {
  if (modals[bodyClass]) {
    modals[bodyClass] -= 1;
  }
}

function count(bodyClass) {
  return modals[bodyClass];
}

function totalCount() {
  return Object.keys(modals).reduce(function (acc, curr) {
    return acc + modals[curr];
  }, 0);
}


//////////////////
// WEBPACK FOOTER
// ./~/react-modal/lib/helpers/refCount.js
// module id = 392
// module chunks = 0